
import React, { useState } from "react";
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import {
    Collapse,
    NavbarBrand,
    Navbar,
    NavItem,
    NavLink,
    Nav,
    Container,
} from "reactstrap";

import { HashLink as Link } from 'react-router-hash-link';

import { FaBriefcase, FaHome, FaPhoneSquareAlt, FaUserLock } from "react-icons/fa";

import Logo from '../../assets/img/logosolo.svg'

import LogoNav from '../../assets/img/logoblanco.svg'

function Navigation() {
    const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
    const [navbarCollapse, setNavbarCollapse] = React.useState(false);

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(prevState => !prevState);

    const toggleNavbarCollapse = () => {
        setNavbarCollapse(!navbarCollapse);
        document.documentElement.classList.toggle("nav-open");
    };

    React.useEffect(() => {
        const updateNavbarColor = () => {
            if (
                document.documentElement.scrollTop > 100 ||
                document.body.scrollTop > 150
            ) {
                setNavbarColor("");
            } else if (
                document.documentElement.scrollTop < 300 ||
                document.body.scrollTop < 300
            ) {
                setNavbarColor("navbar-transparent");
            }
        };

        window.addEventListener("scroll", updateNavbarColor);

        return function cleanup() {
            window.removeEventListener("scroll", updateNavbarColor);
        };
    });
    return (
        <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">

            <Container>

                <div className="navbar-translate">
                    {navbarCollapse == false ?
                        <button
                            aria-expanded={navbarCollapse}
                            className={classnames("navbar-toggler navbar-toggler", {
                                toggled: navbarCollapse,
                            })}
                            onClick={toggleNavbarCollapse}>

                            <span className="navbar-toggler-bar bar1" />
                            <span className="navbar-toggler-bar bar2" />
                            <span className="navbar-toggler-bar bar3" />
                        </button>
                        :
                        <button aria-expanded={navbarCollapse}
                            className={classnames("navbar-toggler navbar-toggler-close ", {
                                toggled: navbarCollapse,
                            })}
                            onClick={toggleNavbarCollapse}>
                            X
                        </button>
                    }
                </div>
                <NavbarBrand data-placement="bottom"
                    href="/"
                    target="_blank"
                    title="Coded by Creative Tim"
                >
                    {navbarColor == "navbar-transparent" ?
                        <img src={LogoNav} className="Logo-Header" />
                        :
                        <img src={Logo} className="LogoOIP-Navbar" />
                    }

                </NavbarBrand>
                <Collapse
                    className="justify-content-end"
                    navbar
                    isOpen={navbarCollapse}>
                    <Nav navbar>
                        <NavItem>
                            <NavLink href="/"><FaHome className="Icons-Navbar" />Inicio</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="trabaja-con-nosotros"><FaBriefcase className="Icons-Navbar" />TRABAJA CON NOSOTROS</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="/contacto"><FaPhoneSquareAlt className="Icons-Navbar" />Contacta con Nostros</NavLink>
                        </NavItem>
                        <NavItem>
                            <Link href="#" className="Private" style={{ border: 0, width: 0 }}>
                                <FaUserLock className="Icons-Navbar" />
                            </Link>

                        </NavItem>
                    </Nav>
                </Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigation;